import { render } from "./SmsForm.vue?vue&type=template&id=000b15c8&scoped=true"
import script from "./SmsForm.vue?vue&type=script&lang=js"
export * from "./SmsForm.vue?vue&type=script&lang=js"

import "./SmsForm.vue?vue&type=style&index=0&id=000b15c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000b15c8"]])

export default __exports__